import React, {Component, useState} from 'react';

import {ChooseBackground, Dialog, ValidatingInput} from '../../../widgets';
import {connect} from 'react-redux';
import actions from '../coupons.actions';
import {uiActions} from '../../../chrome';
import streamActions from '../../../stream/stream.actions';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './AddCoupon.css';
import moment from 'moment';

class AddCoupon extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: null,
			code: '',
			quantity: ''
		};
	}

	generateCouponCode = businessName => {
		const minm = 100;
		const maxm = 999;
		const randomNumber = Math.floor(Math.random() * (maxm - minm + 1)) + minm;

		return businessName.substring(0, 3) + randomNumber;
	};

	componentDidMount() {
		if (
			this.props.session &&
			this.props.session.current &&
			this.props.session.current.user &&
			this.props.session.current.user.businessName
		) {
			let code = this.generateCouponCode(this.props.session.current.user.businessName);

			this.setState({
				code: code || ''
			});
		}
	}

	isValidURL = productLink => {
		if (productLink === '') {
			return true;
		}

		let url;

		try {
			url = new URL(productLink);
		} catch (_) {
			return false;
		}
		return url.protocol === 'http:' || url.protocol === 'https:';
	};

	render() {
		const {
			addDescription,
			addExpiryDate,
			addProductLink,
			addCode,
			addQuantity,
			coupon,
			onSave,
			onCancel,
			session
		} = this.props;

		coupon.code = this.state.code;

		return (
			<Dialog
				title="Add Promotion"
				className="addCouponDialog"
				submitOnEnter={false}
				onSave={onSave}
				onCancel={onCancel}
				disabled={{
					save:
						!coupon.description ||
						!coupon.description.length ||
						!this.state.date ||
						!coupon.code ||
						!coupon.code.length ||
						!coupon.quantity
				}}>
				<ul className="AddCoupon">
					<li>
						<label>
							<h3>Description</h3>
							<textarea
								className="CommunityAddCoupon-entry"
								placeholder="e.g 20% off all electrical work."
								value={coupon.description}
								maxLength={200}
								onChange={addDescription}
								rows="4"
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Expiry Date*</h3>
							<DatePicker
								selected={this.state.date ? this.state.date.toDate() : null}
								onChange={date => {
									const expiry = date ? moment(date) : null;
									this.setState({date: expiry});
									addExpiryDate(expiry);
								}}
								filterDate={day => !moment(day).isAfter(moment().add(30, 'd'), 'day')}
								dateFormat="dd/MM/yyyy"
								placeholderText="Promotion Expiry Date"
								readOnly
								required
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Code*</h3>
							<ValidatingInput
								type="text"
								className="couponCode"
								placeholder="Promotion Code"
								maxLength={256}
								onChange={addQuantity}
								value={coupon.code}
								isValid={!!(coupon.code && coupon.code.length)}
								invalidMessage="Required"
								invalidTitle="Promotion code is required"
								validIcon=""
								readOnly={true}
							/>
							<p className="codeTip">
								A unique code that your customers can use to redeem your coupon. e.g use the code
								B2Me at checkout to redeem deal.
							</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Quantity*</h3>
							<ValidatingInput
								type="text"
								className="quantity"
								placeholder="Total No. Of Coupons - e.g 10"
								onChange={addQuantity}
								value={coupon.quantity}
								isValid={!!(coupon.quantity && coupon.quantity.length)}
								invalidMessage="Required"
								invalidTitle="Quentity is required"
								validIcon=""
							/>
							<p className="codeTip">Only numerical values are allowed.</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Product/Service Link</h3>
							<ValidatingInput
								type="text"
								className="productLink"
								placeholder="e.g https://b2me.com.au/example"
								maxLength={1024}
								onChange={addProductLink}
								value={coupon.productLink}
								/* 	isValid={this.isValidURL(coupon.productLink)}
								invalidMessage="Please enter correct URL"
								invalidTitle="Invalid URL" */
							/>
							<p className="codeTip">
								A link to external webpage or product site to provide more details on service or
								product. (Leave empty if not applicable)
							</p>
						</label>
					</li>
					<li>
						<label>
							<h3>Terms</h3>
							<p className="codeTip">
								`By submitting this promotion, you expressly understand and agree that B2Me
								Australia or its related parties do not provide any approval, endorsement, warranty
								or guarantee, or assumes any liability or responsibility as to the approval,
								provision or redemption of goods arising out of this promotion. For more
								information, visit our website Terms and Conditions`. -{' '}
								<a
									className="terms_link"
									href="/terms201902_1.pdf"
									target="_blank"
									rel="noopener noreferrer">
									Terms of use
								</a>
							</p>
						</label>
					</li>
				</ul>
			</Dialog>
		);
	}
}

const mapStateToProps = state => {
	return {
		community: state.community,
		session: state.session,
		coupon: state.coupon.adding
	};
};

const mapDispatchToProps = dispatch => {
	return {
		addDescription: e => dispatch(actions.couponDescAdding({description: e.target.value})),
		addExpiryDate: date => dispatch(actions.couponExpiryAdding({expiryDate: date})),
		addCode: e => dispatch(actions.couponCodeAdding({code: e.target.value})),
		addQuantity: e => dispatch(actions.couponQuantityAdding({quantity: e.target.value})),
		addProductLink: e => dispatch(actions.couponProductLinkAdding({productLink: e.target.value})),
		onSave: () => {
			dispatch(actions.persistExistingCoupon());
			dispatch(uiActions.uiModal(null));
			dispatch(streamActions.streamPromotionAddModelClosed());
		},
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
			dispatch(streamActions.streamPromotionAddModelClosed());
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AddCoupon);



// WEBPACK FOOTER //
// ./src/community/coupons/add-coupon/AddCoupon.js